import { render, staticRenderFns } from "./DashboardsSwitcher.vue?vue&type=template&id=7b795b07&scoped=true"
import script from "./DashboardsSwitcher.vue?vue&type=script&lang=js"
export * from "./DashboardsSwitcher.vue?vue&type=script&lang=js"
import style0 from "./DashboardsSwitcher.vue?vue&type=style&index=0&id=7b795b07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b795b07",
  null
  
)

export default component.exports